module.exports = __webpack_public_path__ + "static/bg8.9d717fcd.png";